<template>
  <div class="content position-relative">
    <div class="content-text">
      <h3 class="content-title">标准件命名规范</h3>
      <small class="content-small">该命名规则只针对标准件</small>
    </div>

    <div style="min-width: 300px;">
      <el-input v-model="config.modelNameRole" @input="chooseModelNameRole" style="width: 240px;margin-right: 10px;" size="small"/>
      <el-select
        v-model="config.modelNameRole"
        placeholder="请选择标准件命名规范"
        @change="chooseModelNameRole"
        size="small"
        style="width: 40px;"
      >
        <el-option
          v-for="(item,index) in modelRoleList"
          :key="index"
          :label="item.value"
          :value="item.value">
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    config: { default: {} }
  },
  data() {
    return {
      showModelRoleList: false,
      modelRoleList: [//命名规则
        {"value": "标准"},
        {"value": "标准[名称]"},
        {"value": "标准[名称规格]"},
        {"value": "标准名称规格[材料]"},
        {"value": "名称"},
        {"value": "名称[标准]"},
        {"value": "名称 规格"},
        {"value": "名称[规格]"},
        {"value": "名称规格[标准]材料 级别"},
        {"value": '名称[规格]"版本""设计"'},
        {"value": "(名称 规格 标准 加任意字符组合)"},
        {"value": "物料号"},
      ],
    }
  },
  methods: {
    chooseModelNameRole(value) {
      this.$emit('configChange', 'modelNameRole', value);
    },
  },
}
</script>

<style lang="less" scoped>
  .content-small{
    color: #888;
    font-size: 12px;
    margin-top: 6px;
  }
</style>
